import { render, staticRenderFns } from "./EtiquetaComponent.vue?vue&type=template&id=f24e06ba"
import script from "./EtiquetaComponent.vue?vue&type=script&lang=js"
export * from "./EtiquetaComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports